import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { updatReviewParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  updateCommentReactResponse,
  updateCommentReactRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum updateCommentReactState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: updateCommentReactState;
  message: string;
}

const initialState: InitialState = {
  status: updateCommentReactState.initial,
  message: "",
};

export const updateCommentReact = createAsyncThunk(
  "updateCommentReact",
  async (param: { type: string; commentId: number }, { rejectWithValue }) => {
    try {
      const response: updateCommentReactResponse =
        await updateCommentReactRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const updateCommentReactSlice = createSlice({
  name: "updateCommentReact",
  initialState,
  reducers: {
    resetupdateCommentReact: (state) => {
      state.status = updateCommentReactState.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCommentReact.pending, (state) => {
        state.status = updateCommentReactState.inProgress;
      })
      .addCase(updateCommentReact.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = updateCommentReactState.success;
          state.message = message;
        }
      })
      .addCase(updateCommentReact.rejected, (state, action) => {
        state.status = updateCommentReactState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectupdateCommentReact = (state: RootState) =>
  state.updateCommentReact;

export const { resetupdateCommentReact } = updateCommentReactSlice.actions;
export default updateCommentReactSlice.reducer;
